/**
 * Uses shared useCommentAuthorQuery to check if current user's avatar data is ready.
 * Use in editor components to conditionally render only when avatar data is ready.
 */
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { expValEquals } from '@confluence/feature-experiments';

import { useCommentAuthorQuery } from './useCommentAuthorQuery.ts';

export const useCurrentUserAvatarReady = (): boolean => {
	const { userId } = useSessionData();

	const { isReady } = useCommentAuthorQuery(userId ?? undefined, {
		skip: !userId || !expValEquals(
			'confluence_comment_improve_author_paint',
			'isEnabled',
			true,
		),
		fetchPolicy: 'cache-first',
	});

	if (!expValEquals(
		'confluence_comment_improve_author_paint',
		'isEnabled',
		true,
	)) {
		return true;
	}
	if (!userId) {
		return true;
	}
	return isReady;
};
